import React from 'react';
import cx from 'classnames';
import { H2, H3, H4 } from '../../../../Typography';
import { useEmptyState } from '../../context';
import styles from '../../EmptyState.module.scss';
const TitleComponentMap = {
    sm: H4,
    md: H3,
    lg: H2,
};
const Title = ({ children, className, ...props }) => {
    const { size } = useEmptyState();
    const TitleComponent = TitleComponentMap[size];
    return (React.createElement(TitleComponent, { className: cx(styles.title, className), ...props }, children));
};
export default Title;
